import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import { Button } from "reactstrap";
import { FiEdit } from "react-icons/fi";
import { TiUserDelete } from "react-icons/ti";
import apiService from "services/api";
import { CustomAlert, CustomTable } from "components";
import { useNotificationContext } from "contexts";

const RolesPage = () => {
    const { data, isLoading, refetch } = useQuery("parent", () =>
        apiService.role.get()
    );
    const { createNotification } = useNotificationContext();
    const [roleToDelete, setRoleToDelete] = useState({
        firstName: "",
        lastName: "",
        id: "",
    });

    const [displayConfirmationModal, setDisplayConfirmationModal] =
        useState(false);

    const showDeleteModal = (roleToDelete) => {
        setRoleToDelete(roleToDelete);
        setDisplayConfirmationModal(true);
    };

    // Hide the modal
    const hideConfirmationModal = () => {
        setDisplayConfirmationModal(false);
    };

    // Handle the actual deletion of the item
    const submitDelete = async () => {
        await apiService.role
            .delete(roleToDelete.id)
            .then(() => {
                createNotification({
                    type: "success",
                    message: "Successfully deleted member",
                });
                refetch();
            })
            .catch((error) =>
                createNotification({ type: "danger", message: error.message })
            );

        setDisplayConfirmationModal(false);
    };

    const columns = [
        {
            id: "name",
            Header: "Role Name",
            accessor: "name",
            sortable: true,
            filterable: true,
        },
        {
            id: "actions",
            Header: "actions",
            accessor: "actions",
            sortable: false,
            filterable: false,
        },
    ];

    const actions = (row) => (
        <div className="actions-right">
            <Link to={`/role/edit/${row.id}`}>
                <Button
                    color="warning"
                    size="sm"
                    className="btn-icon btn-link edit"
                >
                    <FiEdit size={20} />
                </Button>
            </Link>
            <Button
                color="warning"
                size="sm"
                className="btn-icon btn-link edit"
                onClick={() => showDeleteModal(row)}
            >
                <TiUserDelete className="text-danger" size={20} />
            </Button>
        </div>
    );

    return (
        <div className="content">
            <div className="mt-3">
                <div className="d-flex mb-2">
                    <Link to={`/role/new`}>
                        <button type="button" className="btn btn-info">
                            Add new role
                        </button>
                    </Link>
                </div>

                <CustomAlert
                    title="Remove Role"
                    show={displayConfirmationModal}
                    hideModal={hideConfirmationModal}
                    description={
                        <>
                            Are you sure you want to remove role{" "}
                            <span className="text-danger font-weight-bold">
                                {roleToDelete.name}
                            </span>
                        </>
                    }
                    submitModal={submitDelete}
                    submitButtonText="Delete"
                />

                {!isLoading && (
                    <CustomTable
                        data={data}
                        columns={columns}
                        defaultPageSize={25}
                        title="Roles"
                        actions={actions}
                    />
                )}
            </div>
        </div>
    );
};

export default RolesPage;
